import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

const CHAPTERS = [
  {
    num: "01",
    title: "We left tobacco behind.",
    body: "No nicotine. No tobacco. No 7,000-chemical smoke. Sage & Spirit is not a cigarette that pretends to be healthy — it is a ritual that never needed to apologise.",
  },
  {
    num: "02",
    title: "We returned to the source.",
    body: "Ten botanicals, prescribed by five thousand years of Ayurvedic wisdom, grown organically across three continents and blended by hand in small ceremonial batches.",
  },
  {
    num: "03",
    title: "We made smoke sacred again.",
    body: "Before it was a habit, smoke was an offering. Every Sage & Spirit blend restores that intention — a pause, a breath, a moment that belongs entirely to you.",
  },
];

const Manifesto = () => (
  <section data-testid="manifesto-section" className="relative bg-[#062516] py-28 lg:py-40">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.span
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="text-xs uppercase tracking-[0.3em] text-[#C5A880]"
      >
        The Manifesto
      </motion.span>

      <div className="mt-16 space-y-24 lg:space-y-32">
        {CHAPTERS.map((c, i) => (
          <motion.div
            key={c.num}
            initial={{ opacity: 0, y: 48 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 1, ease: EASE }}
            data-testid={`manifesto-chapter-${c.num}`}
            className={`grid grid-cols-1 lg:grid-cols-12 gap-8 ${i % 2 === 1 ? "lg:text-right" : ""}`}
          >
            <div className={`lg:col-span-2 ${i % 2 === 1 ? "lg:order-2" : ""}`}>
              <span className="font-display text-6xl lg:text-7xl text-stroke-gold select-none">{c.num}</span>
            </div>
            <div className={`lg:col-span-8 ${i % 2 === 1 ? "lg:order-1 lg:col-start-3" : ""}`}>
              <h2 className="font-display text-2xl sm:text-3xl lg:text-4xl text-[#F5F1E8] tracking-tight leading-tight">
                {c.title}
              </h2>
              <p className={`mt-6 text-[#F5F1E8]/65 text-base leading-relaxed font-light max-w-2xl ${i % 2 === 1 ? "lg:ml-auto" : ""}`}>
                {c.body}
              </p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);

export default Manifesto;
